<template>
    <v-card
            flat
            tile
            class="d-flex justify-center align-center"
            height="100%">
        <v-card
                flat
                tile
                class="align-content-center align-stretch">
            <h1 class="text-center">
                {{ title }}
            </h1>
            <PincodeInput
                    v-model="code"
                    :length="6" />
        </v-card>
    </v-card>
</template>

<script>
    import PincodeInput from 'vue-pincode-input';

    export default {
        name: "CodeAccess",
        components: {PincodeInput},
        data() {
            return {
                code: '',
                title: 'Enter form code'
            }
        },
        watch: {
            code(code) {
                if (code.length === 6) {
                    return this.$router.push({
                        name: 'FormByCode',
                        params: {
                            code: this.code
                        }
                    })
                }
            }
        },
        created() {
            document.title = this.title
        }
    }
</script>

<style scoped>

</style>